import { z } from 'zod';

/** true, если URL ведёт на Google Maps (вкл. короткие ссылки-шары). */
export function isGoogleMapsUrl(raw: string): boolean {
  let u: URL;
  try {
    u = new URL(raw);
  } catch {
    return false;
  }
  if (u.protocol !== 'https:' && u.protocol !== 'http:') return false;
  const host = u.hostname.toLowerCase();
  const path = u.pathname.toLowerCase();

  // Короткие шары
  if (host === 'maps.app.goo.gl') return true;
  if (host === 'goo.gl') return path.startsWith('/maps');

  // Полные ссылки google.<tld> (вкл. региональные google.ru/maps и т.п.)
  const isGoogleHost = /^(maps\.|www\.)?google\.[a-z]{2,}(\.[a-z]{2,})?$/.test(host);
  if (!isGoogleHost) return false;
  return host.startsWith('maps.') || path.startsWith('/maps');
}

export const googleMapsUrl = z
  .string()
  .trim()
  .max(2048)
  .refine(isGoogleMapsUrl, { message: 'Нужна ссылка Google Maps' });
